/* WHO MAY SEE WHAT, AND WHO MAY HAND OUT WHAT.
 *
 * These were written twice: once in the app's seats.ts and once in the API's
 * db/scope.ts, with the same default array copied into both. The API's own comment
 * warns against exactly that - "the two-copies failure the risk model already taught" -
 * immediately above a second copy of it. One implementation, here, for the same reason
 * the risk model has one.
 *
 * The HQ seat (`super_admin`) is NOT a gym role. It is never in a visibility list and
 * no screen may ever grant it, which is why it is absent from GYM_ROLES and special-
 * cased in seesCommercials rather than being added to the default.
 */
/** The roles a gym actually hands out, in the order they are offered. */
export const GYM_ROLES = ['gym_admin', 'manager', 'sales', 'coach'];
/* WHO SEES WHAT A MEMBER PAYS, when the gym has not said otherwise. A coach and a
   support coach treat every member the same, and a price is the one fact that makes
   that impossible. */
export const COMMERCIALS_DEFAULT = ['manager', 'gym_admin'];
/** ONLY AN OWNER CHANGES IT. A manager who could grant themselves nothing new could
 *  still grant it to the floor, and that is the gym owner's call about their own
 *  staff. */
export const CAN_SET_VISIBILITY = ['gym_admin', 'super_admin'];
/** Plans, prices, renewal dates, and a lead's value. */
export function seesCommercials(roles, settings) {
    const raw = settings?.['canSeeCommercials'];
    const allowed = Array.isArray(raw) && raw.length ? raw : COMMERCIALS_DEFAULT;
    return (roles ?? []).some(r => r === 'super_admin' || allowed.includes(r));
}
export function canSetVisibility(roles) {
    return (roles ?? []).some(r => CAN_SET_VISIBILITY.includes(r));
}
/* WHAT THIS SEAT MAY HAND OUT. An Owner gets every gym role; a Manager lives inside
   {Support Coach, Coach} and cannot see past it; everybody else grants nothing.
   `super_admin` is deliberately absent from both. */
export function grantableBy(roles) {
    const held = roles ?? [];
    if (held.includes('gym_admin') || held.includes('super_admin'))
        return [...GYM_ROLES];
    if (held.includes('manager'))
        return ['sales', 'coach'];
    return [];
}
